import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";
import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  createBooking(optUserID, bookingData, sendToLine) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking?optUserID=${optUserID}&sendToLine=${sendToLine}`;

    return httpPost(apiUrl, bookingData);
  }

  deleteBooking(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking?bookingID=${_id}`;

    return httpDelete(apiUrl);
  }

  deleteAllBooking(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/pet?petID=${petID}`;

    return httpDelete(apiUrl);
  }

  getBooking(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking?bookingID=${_id}`;

    return httpGet(apiUrl);
  }

  getBookingList(options, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/booking/explore`;

    return httpPost(apiUrl, options);
  }

  getBookingByDateRange(options, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/booking/range`;

    return httpPost(apiUrl, options);
  }

  checkBookingTime(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/check`;

    return httpPost(apiUrl, options);
  }

  modifyBooking(_id, optUserID, bookingData, sendToLine) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking?bookingID=${_id}&optUserID=${optUserID}&sendToLine=${sendToLine}`;

    return httpPut(apiUrl, bookingData);
  }

  bookingCheckIn(_id, record) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/checkIn?bookingID=${_id}&optUserID=${record.optUserID}`;

    return httpPut(apiUrl, record);
  }

  isBookingCheckIn(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/checkIn/status?bookingID=${_id}`;

    return httpGet(apiUrl);
  }

  revokeBookingCheckIn(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/checkIn?bookingID=${_id}`;

    return httpDelete(apiUrl);
  }

  getVerifyBooking(bookingId) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/v2/${Crypto.encrypt(bookingId, CryptoKey)}`;

    return httpGet(apiUrl);
  }
  
  getBookingListV2(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/v2/list`;

    return httpPost(apiUrl, options);
  }

  getBookingByDateRangeV2(options, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/booking/v2/range`;

    return httpPost(apiUrl, options);
  }
  
  approveBookingV2(bookingId, optUserID, bookingData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/v2/${Crypto.encrypt(bookingId, CryptoKey)}/approve?optUserID=${optUserID}`;

    return httpPut(apiUrl, bookingData || {});
  }
  
  cancelBookingV2(bookingId, by, reason, approvalStatus, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/booking/v2/${Crypto.encrypt(bookingId, CryptoKey)}/cancel`;

    return httpPut(apiUrl, {
      by,
      reason,
      optUserID,
      approvalStatus
    });
  }
}
